// @flow

import * as React from 'react';
import {Text} from 'sail/Text';
import './Card.scss';

type CardBodyProps = {|
  children: React.Node,
|};

export const CardBody = ({children}: CardBodyProps) => (
  <Text
    className="Card-body"
    color="gray700"
    weight="regular"
    size={15}
    lineHeight={20}
  >
    {children}
  </Text>
);
